export default "__VITE_ASSET__DygP2HGe__"